import { createContext as D, useState as i, useRef as E, useMemo as M, useContext as R } from "react";
import { useFloating as S, autoUpdate as F, offset as P, flip as U, shift as y, arrow as A, hide as H, useTransitionStyles as L, useClick as j, useHover as q, useDismiss as z, useRole as B, useFocus as G, useInteractions as J } from "@floating-ui/react";
const V = ({
  initialOpen: t = !1,
  placement: w = "top",
  modal: c,
  open: r,
  onOpenChange: x
} = {}, l = "default") => {
  const [h, C] = i(t), [u, T] = i(), [a, b] = i(), o = r ?? h, s = x ?? C, d = E(null), n = S({
    placement: w,
    open: o,
    onOpenChange: s,
    whileElementsMounted: F,
    middleware: [
      P(10),
      U({
        fallbackAxisSideDirection: "end"
      }),
      y({ padding: 10 }),
      A({
        element: d
      }),
      H()
    ]
  }), { context: e } = n, { isMounted: p, styles: f } = L(e), I = j(e, {
    enabled: r == null
  }), g = q(e), O = z(e, {
    outsidePress: !0,
    outsidePressEvent: "pointerdown"
  }), k = B(e), v = G(e), m = J([I, O, v, k, g]);
  return M(
    () => ({
      arrowRef: d,
      open: o,
      isMounted: p,
      styles: f,
      setOpen: s,
      ...m,
      ...n,
      modal: c,
      labelId: u,
      descriptionId: a,
      setLabelId: T,
      setDescriptionId: b,
      tooltipType: l
    }),
    [
      o,
      p,
      f,
      s,
      m,
      n,
      c,
      u,
      a,
      l
    ]
  );
}, K = D(null), W = () => {
  const t = R(K);
  if (t == null)
    throw new Error("Tooltip components must be wrapped in <Tooltip />");
  return t;
};
export {
  K as T,
  W as a,
  V as u
};
//# sourceMappingURL=TooltipContext-BDAX-u97.js.map
